<!--The content below is only a placeholder and can be replaced.-->
<div id="chart">
  <apx-chart *ngIf="chartOptions"
    [series]="chartOptions.series"
    [chart]="chartOptions.chart"
    [xaxis]="chartOptions.xaxis"
    [yaxis]="chartOptions.yaxis"
    [dataLabels]="chartOptions.dataLabels"
    [grid]="chartOptions.grid"
    [markers]="chartOptions.markers"
    [stroke]="chartOptions.stroke"
    [title]="chartOptions.title"
    [labels]="chartOptions.labels"
    [annotations]="chartOptions.annotations"
    [legend]="chartOptions.legend"
    [colors]="chartOptions.colors"
    [tooltip]="chartOptions.tooltip"
    [fill]="chartOptions.fill"
    class="d-block">
  </apx-chart>
</div>